import React, { createRef, useRef } from 'react';

export const useMultipleRefs = hoyManyRefs => {
    const arrayOfCharacters = Array.from(Array(hoyManyRefs).keys());
    const myRefs = useRef([]);
    myRefs.current = arrayOfCharacters.map((element, i) => myRefs.current[i] || createRef());

    return {
        allReferences: myRefs.current,
    };
};
